import type { ModuleManifest } from "./types";

export const acceptanceManifest: ModuleManifest = {
  name: "acceptance",
  label: "Accettazione",
  labelPlural: "Accettazioni",
  coreBOSModule: "evAcceptance",
  wsidPrefix: "77x",
  type: "standard",
  routes: {
    list: "/acceptance",
    show: "/acceptance/show/:id",
    create: "/acceptance/create",
    edit: "/acceptance/edit/:id",
  },
  navigation: {
    icon: "CheckCircleOutlined",
    order: 7,
    group: "CRM",
    hidden: false,
  },
  routing: {
    keywords: ["acceptance", "accettazione", "consenso"],
    searchFields: ["acctitle"],
    defaultSort: { field: "acclastdate", order: "desc" },
  },
  context: { supported: false, entityKey: "acceptance" },
  fields: [
    { name: "acctitle", label: "Titolo", type: "string", required: true },
    { name: "acceptance_status", label: "Stato", type: "picklist" },
    { name: "acclastdate", label: "Data", type: "date" },
    { name: "accmethod", label: "Metodo", type: "picklist" },
    { name: "acclevelescal", label: "Livello Escalation", type: "string" },
    { name: "email_opened", label: "Email Aperta", type: "boolean" },
    { name: "acctopolicy", label: "Policy", type: "reference" },
    { name: "acceptancetocontent", label: "Contenuto", type: "reference" },
    { name: "pacclinktocontact", label: "Contatto", type: "reference" },
    { name: "acctoemployee", label: "Dipendente", type: "reference" },
    { name: "evacceptance_no", label: "Numero", type: "string" },
    { name: "description", label: "Descrizione", type: "text" },
    { name: "contact_type", label: "Tipo Contatto", type: "picklist" },
    { name: "assigned_user_id", label: "Assegnato a", type: "reference" },
  ],
  relationships: [
    {
      module: "evPolicies",
      field: "acctopolicy",
      relation: "one-to-many",
      label: "Policy",
      icon: "FileProtectOutlined",
      displayField: "title",
    },
    {
      module: "cbContent",
      field: "acceptancetocontent",
      relation: "one-to-many",
      label: "Contenuto",
      icon: "ReadOutlined",
      displayField: "title",
    },
    {
      module: "Contacts",
      field: "pacclinktocontact",
      relation: "one-to-many",
      label: "Contatto",
      icon: "UserOutlined",
      displayField: "lastname",
    },
  ],
  requiredFields: ["acctitle"],
  viewStrategy: "generic",
};
